module.exports = __webpack_public_path__ + "static/kooloos-werkenbij-2280c9a5bb6c0dac9f37a7ead1524729.png";